// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ModalDetailed_modalContent__1tmFg","header":"ModalDetailed_header__ARoVD","description":"ModalDetailed_description__2FxAY"};